import { FC } from 'react';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  HStack,
  PopoverBody,
  PopoverCloseButton,
  PopoverArrow,
  PopoverContent,
  Portal,
  PopoverTrigger,
  Popover,
  Button,
} from '@chakra-ui/react';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from '../../../consts/routes';
import { useAdminCardDecksTraits } from '@olagg/api-hooks';
import { CardDeckTrait, PermissionEnum, OlaggModule } from '@olagg/db-types';
import useRoles from '../../../features/Roles/hooks/useRoles';

interface TraitsTableProps {
  traits: CardDeckTrait[];
  onUpdate: () => void;
}

const TraitsTable: FC<TraitsTableProps> = ({ traits, onUpdate }) => {
  const navigate = useNavigate();
  const { deck_id } = useParams();
  const { missingPermission } = useRoles();
  
  if (!deck_id) return null;

  const { deleteTrait } = useAdminCardDecksTraits(deck_id);

  return (
    <Table
      variant="striped"
      colorScheme="olaggPurple"
      fontSize="18px"
      position='relative'
    >
      <Thead>
        <Tr>
          <Th>Nombre</Th>
          <Th>Layer</Th>
          <Th>Acciones</Th>
        </Tr>
      </Thead>
      <Tbody>
        {traits.map((trait) => (
          <Tr key={trait.id}>
            <Td>{trait.name}</Td>
            <Td>{trait.layer}</Td>
            <Td>
              <HStack spacing={2}>
                <Button
                  size={'sm'} padding='17px 14px'
                  variant="outlinedGradient"
                  onClick={() => navigate(generatePath(ROUTES.CARD_DECKS.variants.all, { deck_id, trait_id: trait.id }))}
                >
                  Variantes
                </Button>
    
                <Button size={'sm'} padding='16px 14px' colorScheme='green'
                  onClick={(e) => { e.stopPropagation(); navigate(generatePath(ROUTES.CARD_DECKS.traits.update, { deck_id, id: trait.id })); }}
                  leftIcon={<FaEdit />}
                  isDisabled={missingPermission(OlaggModule.CardDeck, PermissionEnum.EDIT)}
                  >
                  Editar
                </Button>
                      
                <Popover>
                  <PopoverTrigger>
                    <Button
                      size={'sm'} padding='16px 14px' ml={0} colorScheme="red"
                      onClick={(e) => e.stopPropagation()}
                      leftIcon={<FaTrash />}
                      isDisabled={missingPermission(OlaggModule.CardDeck, PermissionEnum.DELETE)}
                    >
                      Eliminar
                    </Button>
                  </PopoverTrigger>
                  <Portal>
                    <PopoverContent>
                      <PopoverArrow />
                      <PopoverCloseButton />
                      <PopoverBody>
                        <Button width={'100%'} colorScheme='red'
                          onClick={async (e) => { e.stopPropagation(); await deleteTrait(trait.id); onUpdate(); }}
                        >
                          Confirmar Eliminar
                        </Button>
                      </PopoverBody>
                    </PopoverContent>
                  </Portal>
                </Popover>
              </HStack>
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
};

export default TraitsTable; 